import { useMemo } from 'react';
import { generateRecommendations } from '../../../engine/aiAdvisor';

type Props = {
  baselineTotalKg: number;
  optimizedTotalKg: number;
  supplierScore: number;
  industryAvgKgPerEmployee: number;
  regionEnergyKgPerKWh: number;
  complianceScore: number;
};

export function AdvisorPanel(props: Props) {
  const recs = useMemo(() => generateRecommendations(props), [props]);
  return (
    <div className="space-y-2">
      <div className="font-orbitron text-evat-gold">AI Advisor</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {recs.map((r, idx) => (
          <div key={idx} className="border border-evat-neon/50 rounded p-3 bg-black/60">
            <div className="flex items-center justify-between">
              <div className="text-evat-neon">{r.actionTitle}</div>
              <span className="text-xs text-neutral-400">Diff: {r.difficulty}/5</span>
            </div>
            <div className="text-sm text-neutral-300 mt-1">Saved CO2: <span className="text-evat-gold">{r.estimated_co2_saved.toFixed(0)} kg</span></div>
            <div className="text-sm text-neutral-300">Cost savings: <span className="text-evat-gold">€{r.estimated_cost_savings.toFixed(0)}</span></div>
            <div className="text-xs text-neutral-500 mt-1">Time: {r.time_to_impact} • {r.taxonomy_align ? 'Taxonomy-aligned' : 'Not aligned'}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdvisorPanel;














